import Farm from "./reducers/farm";
import { createStore, combineReducers } from "redux";

export default createStore(
    combineReducers({
        farm: Farm,
    })
);
